module.exports = __webpack_public_path__ + "static/media/vinglabs_analytics_color_transparent.b85e06b3.png";